import { getParent, types } from 'mobx-state-tree';
import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
const getCorrectionsDetailsAsync = createAsync(body => {
  return async function getCorrectionsDetails(options) {
    const resp = await api.Corrections.getCorrectionsDetails(body, options);
    const _getParent = getParent(this),
      corrections = _getParent.corrections;
    corrections.setCorrectionsDetailsAfterLoad(body.allocationCycleId, resp);
    return resp;
  };
});
const CorrectionDraft = types.model('CorrectionDraft', {
  approvedCorrection: types.number,
  originalCharge: types.number,
  recommendedCharge: types.number
});
const CorrectionAllocations = types.model('CorrectionAllocations', {
  commonAreaDeduction: types.number,
  correctedUtilityCharge: types.number,
  correctionDraft: CorrectionDraft,
  correctedNumberOfDays: types.number,
  correctedCommonAreaDeductionAmount: types.number,
  correctedGoodwillDeductionAmount: types.number,
  correctedTotalDeductionsAmount: types.number,
  correctedTotalUtilitiesCharge: types.number,
  fullname: types.string,
  goodwillDeduction: types.number,
  occupantsCount: types.number,
  occupancyFactor: types.number,
  originalCommonAreaDeductionAmount: types.number,
  originalGoodwillDeductionAmount: types.number,
  originalNumberOfDays: types.number,
  originalTotalDeductionsAmount: types.number,
  originalTotalUtilitiesCharge: types.number,
  originalUtilityCharge: types.number,
  residencyId: types.string,
  residentAccountId: types.string,
  unitId: types.string,
  unitName: types.string,
  utilityCap: types.maybeNull(types.number)
});
const CorrectionBills = types.model('CorrectionBills', {
  absorption: types.number,
  billEndDateOnly: types.string,
  billStartDateOnly: types.string,
  commonAreaDeduction: types.number,
  correctedBillAmount: types.number,
  correctedBillId: types.string,
  correctionAllocations: types.array(CorrectionAllocations),
  correctedChargesTotal: types.number,
  // not used
  correctedTotalBillAmount: types.number,
  correctedRecovery: types.number,
  goodwillDeduction: types.number,
  originalChargesTotal: types.number,
  // not used
  originalBillAmount: types.number,
  originalBillId: types.string,
  originalRecovery: types.number,
  originalTotalBillAmount: types.number,
  totalDeductions: types.number,
  utilityId: types.string,
  utilityTypeName: types.maybeNull(types.string)
});
const CorrectionBillingCycles = types.model('CorrectionBillingCycles', {
  correctedBillingCycleId: types.string,
  correctionBills: types.array(CorrectionBills),
  originalBillingCycleId: types.string
});
const CorrectionAllocationCycles = types.model('CorrectionAllocationCycles', {
  correctionBillingCycles: types.array(CorrectionBillingCycles),
  originalAllocationCycleId: types.string,
  correctedAllocationCycleId: types.string,
  month: types.number,
  year: types.number
});
const CorrectionTrigger = types.model('CorrectionTrigger', {
  billingStartDateOnlyNew: types.maybeNull(types.string),
  billingStartDateOnlyOriginal: types.maybeNull(types.string),
  companyId: types.maybeNull(types.string),
  correctionTriggerType: types.string,
  firstname: types.string,
  lastname: types.string,
  moveOutDateOnlyNew: types.maybeNull(types.string),
  moveOutDateOnlyOriginal: types.maybeNull(types.string),
  propertyId: types.string,
  residencyId: types.string,
  residentAccountId: types.string,
  unitId: types.string,
  unitName: types.string
});
const UtilitySummaryEntry = types.model('UtilitySummaryEntry', {
  amount: types.number,
  utilityId: types.string,
  utilityTypeName: types.string
});
const ResidentSummaryEntry = types.model('ResidentSummaryEntry', {
  firstname: types.string,
  fullname: types.string,
  lastname: types.string,
  residencyId: types.string,
  residentAccountId: types.string,
  totalAmount: types.number,
  unitId: types.string,
  unitName: types.string,
  utilitySummaryEntries: types.array(UtilitySummaryEntry)
});
const CorrectionSummary = types.model('CorrectionSummary', {
  absorption: types.maybeNull(types.number),
  residentSummaryEntries: types.array(ResidentSummaryEntry)
});
const CorrectionsDetails = types.model('CorrectionsDetails', {
  correctionAllocationCycles: types.array(CorrectionAllocationCycles),
  correctionId: types.string,
  correctionSummary: CorrectionSummary,
  correctionTriggers: types.array(CorrectionTrigger),
  createdOnAllocationCycleId: types.string,
  isExcluded: types.boolean
}).actions(store => {
  return {
    setIsExcluded(isExcluded) {
      try {
        store.isExcluded = isExcluded;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
});
const CorrectionsStore = types.model('CorrectionsStore', {
  correctionsDetailsValue: types.map(CorrectionsDetails),
  hasCorrectionsDetailsValue: types.optional(types.boolean, false),
  getCorrectionsDetailsAsync
}).actions(store => {
  return {
    setCorrectionsDetailsAfterLoad(allocationCycleId, d) {
      try {
        if (d.response === null) store.hasCorrectionsDetailsValue = false;else {
          store.correctionsDetailsValue.set(allocationCycleId, d.response);
          store.hasCorrectionsDetailsValue = true;
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
}).views(store => ({
  get correctionsDetails() {
    return store.correctionsDetailsValue;
  },
  get hasCorrectionsDetails() {
    return store.hasCorrectionsDetailsValue;
  }
}));
export const corrections = types.optional(CorrectionsStore, {});